var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "playstore 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.242 3.595C5.089 3.752 5 3.998 5 4.317V15.678C5 15.997 5.089 16.243 5.242 16.401L5.28 16.435L11.719 10.072V9.92301L5.281 3.561L5.242 3.595Z",
    fill: "#B1B3C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.862 12.193L11.72 10.072V9.923L13.866 7.802L13.913 7.832L16.455 9.26C17.182 9.668 17.182 10.335 16.455 10.743L13.913 12.171L13.862 12.193Z",
    fill: "#B1B3C0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.913 12.168L11.72 10L5.242 16.401C5.484 16.652 5.875 16.682 6.322 16.431L13.913 12.168Z",
    fill: "#858894"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.913 7.82799L6.322 3.56499C5.876 3.31799 5.48 3.34799 5.242 3.59899L11.72 9.99999L13.913 7.82799Z",
    fill: "#999BAA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/play-store.8ed0d184d01cfe70dc77e9295a27d881.svg";
export { ForwardRef as ReactComponent };